
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';

import FAQ from './FAQ';
import UsePageTracking from '../components/usePageTracking';


function Mumbaitotrimbkeshwertaxi() {



    const cardData =
    {
        keyword: 'Mumbai to Trimbakeshwar Taxi ',
        heading: 'Morya Cabs: Mumbai to Trimbakeshwar Taxi',
        headingDescription: 'Morya Cabs provides dependable, comfortable, and affordable taxi services from Mumbai to Trimbakeshwar. Whether you are embarking on a religious pilgrimage or a peaceful retreat, our well-maintained vehicles and experienced drivers ensure a safe and pleasant journey. Mumbai to Trimbakeshwar is approximately 170 km, and the journey usually takes around 4 to 5 hours by road. Enjoy a hassle-free and comfortable ride to one of the most revered Jyotirlingas in India with Morya Cabs.',

        top: 'Top Places to Visit in Trimbakeshwar with Morya Cabs',

"topPlaces": [
    {
        "title": "Trimbakeshwar Temple",
        "location": "Trimbakeshwar, Maharashtra",
        "description": "Trimbakeshwar Temple is one of the twelve Jyotirlingas, making it a prime pilgrimage site for devotees of Lord Shiva. The temple’s architecture, nestled in the scenic surroundings of the Sahyadri hills, offers a tranquil spiritual experience. The temple is known for its sacred 'Trimbak' or three-faced idol representing Lord Shiva, Vishnu, and Brahma."
    },
    {
        "title": "Brahmagiri Hill",
        "location": "Trimbakeshwar, Maharashtra",
        "description": "Brahmagiri Hill, situated near the Trimbakeshwar Temple, is considered a spiritual spot where Lord Vishnu meditated. It offers a serene environment with breathtaking views of the valleys below. The trek to the hilltop is rewarding, providing a peaceful retreat for nature lovers and spiritual seekers alike."
    },
    {
        "title": "Saptashrungi",
        "location": "Near Trimbakeshwar, Maharashtra",
        "description": "Saptashrungi is a sacred hill located approximately 60 km from Trimbakeshwar. It is home to the Saptashrungi Mata Temple, one of the 51 Shakti Peethas. Pilgrims must climb several steps to reach the temple, but the panoramic views of the surrounding mountains make the journey worthwhile."
    },
    {
        "title": "Pandav Leni Caves",
        "location": "Near Trimbakeshwar, Maharashtra",
        "description": "Pandav Leni is a group of 24 ancient Buddhist caves carved into the hills near Trimbakeshwar. These caves, dating back to the 1st century BC, were used as meditation and living spaces by Buddhist monks. The intricate carvings and serene atmosphere make this a great spot for history buffs and nature enthusiasts."
    },
    {
        "title": "Ganga Ghat",
        "location": "Trimbakeshwar, Maharashtra",
        "description": "Ganga Ghat, located near the Godavari River in Trimbakeshwar, is an important bathing ghat where devotees take holy dips to purify themselves. The peaceful ambiance and spiritual significance of the ghat make it a must-visit location for those seeking to connect with their inner peace."
    },
    {
        "title": "Kedareshwar Temple",
        "location": "Trimbakeshwar, Maharashtra",
        "description": "Located at the foot of Brahmagiri Hill, the Kedareshwar Temple is dedicated to Lord Shiva. It is a beautiful and peaceful site to visit after the trek to Brahmagiri Hill, where devotees can meditate and seek blessings from Lord Shiva."
    },
    {
        "title": "Anjneri Hill",
        "location": "Near Trimbakeshwar, Maharashtra",
        "description": "Anjneri Hill, believed to be the birthplace of Lord Hanuman, is a short drive from Trimbakeshwar. The hill is a popular destination for trekkers and pilgrims, offering scenic views and a peaceful environment. A visit to the Anjneri Hill temple provides spiritual rejuvenation."
    },
    {
        "title": "Kalaram Sansthan Temple",
        "location": "Nashik, Maharashtra",
        "description": "Kalaram Sansthan Temple, located in Nashik (about 30 km from Trimbakeshwar), is dedicated to Lord Rama. The temple houses a black stone idol of Lord Rama and is a significant place for devotees to seek divine blessings."
    },
    {
        "title": "Vani Village",
        "location": "Near Trimbakeshwar, Maharashtra",
        "description": "Vani Village is located about 40 km from Trimbakeshwar and is home to the Vani Temple, dedicated to Goddess Saptashrungi. The temple is set in a picturesque location surrounded by hills, making it a perfect spot for spiritual reflection and tranquility."
    },
    {
        "title": "Shivneri Fort",
        "location": "Near Trimbakeshwar, Maharashtra",
        "description": "Shivneri Fort, about 40 km from Trimbakeshwar, is a historic fort where the famous Maratha king Shivaji Maharaj was born. The fort offers great views and is an important site for history enthusiasts and those interested in learning more about Maratha history."
    }
],


"services": [
    {
        "name": "Mumbai to Trimbakeshwar Taxi",
        "description": "Morya Cab offers convenient and reliable taxi services from Mumbai to Trimbakeshwar. Our services are designed to make your trip comfortable, safe, and hassle-free. Travel with us for a smooth and stress-free ride."
    },
    {
        "name": "Mumbai to Trimbakeshwar Cab Service",
        "description": "Morya Cab provides high-quality cab services from Mumbai to Trimbakeshwar, ensuring that you reach your destination comfortably and on time. Whether you're traveling for business, leisure, or religious purposes, our fleet is ready to serve your needs."
    },
    {
        "name": "Mumbai to Trimbakeshwar One Way Taxi",
        "description": "Looking for a one-way trip to Trimbakeshwar? Morya Cab offers affordable one-way taxi services from Mumbai to Trimbakeshwar. Book online or over the phone for a simple and seamless experience."
    },
    {
        "name": "Mumbai to Trimbakeshwar Taxi Fare",
        "description": "We offer transparent pricing for our Mumbai to Trimbakeshwar taxi services. Morya Cab provides competitive fares, ensuring a great balance of affordability and comfort for all our customers."
    },
    {
        "name": "Mumbai to Trimbakeshwar Car Hire",
        "description": "For those looking for flexibility, Morya Cab offers car hire services from Mumbai to Trimbakeshwar. Choose from a variety of vehicles to suit your travel needs and enjoy the journey in comfort and style."
    },
    {
        "name": "Mumbai to Trimbakeshwar Innova",
        "description": "Morya Cab offers the Innova for those who prefer a spacious, comfortable, and premium ride. Perfect for families or groups, the Innova ensures a smooth, relaxing ride from Mumbai to Trimbakeshwar."
    },
    {
        "name": "Taxi from Mumbai to Trimbakeshwar",
        "description": "Morya Cab provides a professional taxi service from Mumbai to Trimbakeshwar. Our experienced drivers and well-maintained vehicles ensure you have a safe and pleasant journey."
    },
    {
        "name": "Trimbakeshwar Trip from Mumbai",
        "description": "Embark on a smooth and enjoyable trip from Mumbai to Trimbakeshwar with Morya Cab. We understand the importance of your visit, and our services are tailored to provide the utmost convenience."
    },
    {
        "name": "Mumbai to Trimbakeshwar by Cab",
        "description": "Choose Morya Cab for your journey from Mumbai to Trimbakeshwar by cab. We ensure a comfortable and safe ride, making your trip enjoyable and stress-free."
    },
    {
        "name": "Mumbai to Trimbakeshwar Online Booking",
        "description": "Booking a taxi from Mumbai to Trimbakeshwar is easy with Morya Cab’s online booking platform. Secure your ride at the best price and ensure a smooth trip ahead."
    },
    {
        "name": "Mumbai to Trimbakeshwar Sedan",
        "description": "For a comfortable and affordable ride, Morya Cab offers the Sedan for your Mumbai to Trimbakeshwar journey. Whether you are traveling alone or with a small group, the Sedan provides a cozy and efficient travel option."
    },
    {
        "name": "Trimbakeshwar Cab Service from Mumbai",
        "description": "Morya Cab’s Trimbakeshwar cab service from Mumbai is designed to offer a safe and comfortable journey. Our professional drivers know the best routes, ensuring you reach Trimbakeshwar without any hassle."
    },
    {
        "name": "Taxi Booking Mumbai to Trimbakeshwar",
        "description": "Easily book your taxi from Mumbai to Trimbakeshwar with Morya Cab. You can book a ride online or by calling us for assistance with your reservation."
    },
    {
        "name": "Mumbai to Trimbakeshwar Drop Taxi",
        "description": "Morya Cab offers drop taxi services from Mumbai to Trimbakeshwar. Our reliable service ensures you are dropped off at your destination safely, without any delays."
    },
    {
        "name": "Trimbakeshwar Taxi Charges",
        "description": "At Morya Cab, we ensure competitive and transparent pricing for our Mumbai to Trimbakeshwar taxi services. Get in touch with us to know more about the taxi charges for your journey."
    },
    {
        "name": "Contact Information for Morya Cab",
        "description": "For more details or to book your ride, contact Morya Cab at +91 9371304510. Our customer service team is ready to assist you with your booking and any other inquiries!"
    }
],


tableData: [
    ["Mumbai to Trimbakeshwar Taxi", "-Mumbai to Trimbakeshwar Cab Service"],
    ["Mumbai to Trimbakeshwar One Way Taxi", "-Mumbai to Trimbakeshwar Taxi Fare"],
    ["Mumbai to Trimbakeshwar Car Hire", "-Mumbai to Trimbakeshwar Innova"],
    ["Taxi from Mumbai to Trimbakeshwar", "-Trimbakeshwar Trip from Mumbai"],
    ["Mumbai to Trimbakeshwar by Cab", "-Mumbai to Trimbakeshwar Online Booking"],
    ["Mumbai to Trimbakeshwar Sedan", "-Trimbakeshwar Cab Service from Mumbai"],
    ["Taxi Booking Mumbai to Trimbakeshwar", "-Mumbai to Trimbakeshwar Drop Taxi"],
    ["Trimbakeshwar Taxi Charges", ""]
],

whychoose: [
    {
        "WhyChooseheading": "Reliable and On-Time Service",
        "WhyChoosedescription": "At Morya Cab, we understand the importance of timely travel, especially when visiting sacred places like Trimbakeshwar. Our drivers ensure prompt pickups and timely drop-offs, allowing you to enjoy a smooth and hassle-free journey from Mumbai to Trimbakeshwar."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "We provide well-maintained vehicles designed for comfort and convenience. With air-conditioned interiors, ample legroom, and comfortable seating, our taxis are perfect for long-distance travel, ensuring you have a relaxed and enjoyable ride."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced drivers are familiar with the best routes from Mumbai to Trimbakeshwar, ensuring a safe and smooth ride. They are professional, courteous, and committed to making your journey as comfortable and enjoyable as possible."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Morya Cab offers competitive pricing for your Mumbai to Trimbakeshwar taxi. We pride ourselves on transparency, with no hidden charges, ensuring you get the best value for your money and a clear understanding of the cost upfront."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our top priority. All our vehicles are regularly serviced and equipped with modern safety features, including airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols to ensure a worry-free travel experience."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Whether you need a ride early in the morning or late at night, Morya Cab is available round-the-clock. Our customer service team is always ready to assist you with your bookings and ensure a smooth travel experience at any time."
    },
    {
        "WhyChooseheading": "Hassle-Free Booking Process",
        "WhyChoosedescription": "Booking a taxi for your Mumbai to Trimbakeshwar trip is easy with Morya Cab. You can book online through our website or mobile app, or contact our customer service team for personalized assistance with your booking."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "We offer customized travel packages to suit your specific needs. Whether you’re looking for a direct trip or wish to make stops along the way, we can tailor the journey to your preferences, ensuring you get the most out of your travel."
    }
]













    }


    const faqData = [
        {
          question: "How can I book a Mumbai to Trimbakeshwar taxi with Morya Cab?",
          answer: "Booking your taxi is simple! You can book online via our website or mobile app, or contact our customer service team for assistance with your booking."
        },
        {
          question: "Are the drivers experienced for long-distance travel?",
          answer: "Yes, our drivers are highly experienced in long-distance travel. They ensure a smooth, safe, and comfortable journey from Mumbai to Trimbakeshwar."
        },
        {
          question: "What types of vehicles are available for Mumbai to Trimbakeshwar travel?",
          answer: "We offer a variety of well-maintained vehicles, including sedans, SUVs, and premium cars, all designed to provide comfort during your long journey."
        },
        {
          question: "How do I pay for my Mumbai to Trimbakeshwar taxi rental?",
          answer: "We accept multiple payment options, including cash, credit/debit cards, and online payments via our app for your convenience."
        },
        {
          question: "Can I book a round trip from Mumbai to Trimbakeshwar?",
          answer: "Yes, you can book a round-trip taxi. Just provide your return details during booking, and we’ll arrange your return journey from Trimbakeshwar to Mumbai."
        },
        {
          question: "Are there any extra charges for waiting or detours?",
          answer: "Any extra charges for waiting or detours will be communicated to you upfront, ensuring transparency and no surprises in pricing."
        },
        {
          question: "Can I hire a taxi for sightseeing in Trimbakeshwar?",
          answer: "Yes, we offer sightseeing services in Trimbakeshwar. Explore popular spots like the Trimbakeshwar Temple and surrounding areas with a trusted driver to guide you."
        },
        {
          question: "What is the luggage allowance for a Mumbai to Trimbakeshwar taxi?",
          answer: "Our vehicles can accommodate standard luggage. If you have more luggage or specific requirements, please let us know when booking, and we will make necessary arrangements."
        },
        {
          question: "Is Morya Cab available for corporate travel to Trimbakeshwar?",
          answer: "Yes, we provide corporate travel services to Trimbakeshwar. Whether it’s for a business trip or a team outing, we can customize the travel package to meet your company's needs."
        },
        {
          question: "Why should I choose Morya Cab for Mumbai to Trimbakeshwar travel?",
          answer: "Morya Cab offers reliable, safe, and affordable taxi services. With well-maintained vehicles, professional drivers, and a focus on safety and comfort, we ensure a smooth and enjoyable journey for all your travel needs."
        }
      ];
      
      const testimonialData = [
        {
          id: 1,
          name: 'Mr. Suresh Nair',
          role: 'Religious Traveler',
          review: 'We traveled from Mumbai to Trimbakeshwar for a religious trip, and the experience with Morya Cab was fantastic. The vehicle was very comfortable, and the driver was professional and courteous. Highly recommended!',
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        },
        {
          id: 2,
          name: 'Mrs. Anita Joshi',
          role: 'Family Traveler',
          review: 'Our family used Morya Cab for our trip from Mumbai to Trimbakeshwar. The car was clean and spacious, and the driver was friendly and knowledgeable about the area. We had a great experience!',
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        }
      ];
      
      
      
      
      
      
            
            
            
      











    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9371304510",
            "+91 8379975860",



        ],
        email: "booking@moryacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Shirdi Taxi",
            link: "/Pune-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Bhimashankar Taxi",
            link: "/Pune-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai Taxi",
            link: "/Pune-to-Mumbai-Taxi"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala Taxi",
            link: "/Pune-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mahabaleshwar Taxi",
            link: "/Pune-to-Mahabaleshwar-Taxi"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Aurangabad Taxi",
            link: "/Pune-to-Aurangabad-Taxi"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Nashik-Trimbakeshwar Taxi",
            link: "/Pune-to-Nashik-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Car Rental Services",
            link: "/Pune-Car-Rental-Services"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Ashtavinayak Taxi",
            link: "/Pune-to-Ashtavinayak-Taxi"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Goa Taxi",
            link: "/Pune-to-Goa-Taxi"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Solapur Taxi",
            link: "/Pune-to-Solapur-Taxi"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Hyderabad Cab",
            link: "/Pune-to-Hyderabad-Cab"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Kolhapur Taxi",
            link: "/Pune-to-Kolhapur-Taxi"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Bangalore Taxi",
            link: "/Pune-to-Bangalore-Taxi"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Indore Taxi",
            link: "/Pune-to-Indore-Taxi"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai to Shirdi Taxi",
            link: "/Mumbai-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Borivali to Pune Taxi Service",
            link: "/Borivali-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Vasai to Pune Taxi Service",
            link: "/Vasai-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Dombivli to Pune Taxi Services",
            link: "/Dombivli-to-Pune-Taxi-Services"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Dadar to Shirdi Taxi Service",
            link: "/Dadar-to-Shirdi-Taxi-Service"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Trimbakeshwar Taxi",
            link: "/Mumbai-to-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Bhimashankar Taxi",
            link: "/Mumbai-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai Central to Pune Taxi",
            link: "/Mumbai-Central-to-Pune-Taxi"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Thane to Pune Taxi Service",
            link: "/Thane-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Nashik Taxi",
            link: "/Mumbai-to-Nashik-Taxi"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Lonavala Taxi",
            link: "/Mumbai-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Mumbai Airport to Pune Taxi",
            link: "/Mumbai-Airport-to-Pune-Taxi"
        }
    ];


    const images = [
        { src: "/images/our-fleet/3.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/4.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/5.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/7.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/8.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/10.jpg", alt: "Image 1" },
       
    ];


    const jsonLD = {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Morya Cab Services",
        "description": "Book your Mumbai to Trimbakeshwar taxi with Morya Cab. Affordable and reliable one-way taxi, drop taxi, and car hire services. Call +91 9371304510 for bookings!",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Office No. 5, First Floor, Sunshine Complex, Near ABC Chowk, Pune",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411014",
          "addressCountry": "IN"
        },
        "telephone": "+91-9371304510",
        "url": "https://moryacab.com/",
        "logo": "https://moryacab.com/img/logo.jpg",
        "image": [
          "https://moryacab.com/img/mumbai-to-trimbakeshwar-taxi.jpg",
          "https://moryacab.com/img/mumbai-to-trimbakeshwar-cab-service.jpg"
        ],
        "priceRange": "₹2000 - ₹3500",
        "offers": {
          "@type": "Offer",
          "url": "https://moryacab.com/mumbai-to-trimbakeshwar-taxi-service",
          "priceCurrency": "INR",
          "price": 2500,
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": 4.7,
          "reviewCount": 100
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Sandeep Sharma"
            },
            "datePublished": "2024-07-15",
            "reviewBody": "Excellent service for our trip to Trimbakeshwar. The driver was very professional and the car was clean and comfortable. Highly recommended."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Anita Patil"
            },
            "datePublished": "2024-10-21",
            "reviewBody": "Affordable and reliable taxi service. The booking process was easy, and the journey was smooth. I would definitely use their service again for my next trip."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Mumbai to Trimbakeshwar Taxi Service",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 19.8985,
            "longitude": 73.5131
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://moryacab.com/mumbai-to-trimbakeshwar-taxi-service"
        },
        "keywords": "mumbai to trimbakeshwar taxi, mumbai to trimbakeshwar cab service, mumbai to trimbakeshwar one way taxi, mumbai to trimbakeshwar taxi fare, mumbai to trimbakeshwar car hire, mumbai to trimbakeshwar innova, taxi from mumbai to trimbakeshwar, trimbakeshwar trip from mumbai, mumbai to trimbakeshwar by cab, mumbai to trimbakeshwar online booking, mumbai to trimbakeshwar sedan, trimbakeshwar cab service from mumbai, taxi booking mumbai to trimbakeshwar, mumbai to trimbakeshwar drop taxi, trimbakeshwar taxi charges"
      };


    return (
        <div>
<UsePageTracking/>
<Helmet>
        <title>Mumbai to Trimbakeshwar Taxi | Affordable & Reliable Taxi Service | Call: +91 9371304510</title>
        <meta
          name="description"
          content="Book your Mumbai to Trimbakeshwar taxi with Morya Cab. Affordable and reliable one-way taxi, drop taxi, and car hire services. Call +91 9371304510."
        />
        <meta name="keywords" content="mumbai to trimbakeshwar taxi, mumbai to trimbakeshwar cab service, one way taxi, affordable taxi service" />
        <meta property="og:title" content="Mumbai to Trimbakeshwar Taxi | Morya Cab Services" />
        <meta property="og:description" content="Book your Mumbai to Trimbakeshwar taxi with Morya Cab. Affordable and reliable one-way taxi, drop taxi, and car hire services." />
        <meta property="og:url" content="https://moryacab.com/mumbai-to-trimbakeshwar-taxi-service" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://moryacab.com/img/mumbai-to-trimbakeshwar-taxi.jpg" />
        <script type="application/ld+json">
          {JSON.stringify(jsonLD)}
        </script>
      </Helmet>

            <div className="breadcumb-wrapper" style={{ backgroundImage: 'url(/img/bg/breadcumb-bg.jpg)' }}>
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/21.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                               style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Morya Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                                            {Images.map((e) => {
    return (
        <div className="box1" key={e.text}>
            <a
                href={e.link} // Use the separate link for each item
                className="d-flex justify-content-around align-items-center"
            >
                <div className="b1">
                    <img src={e.place} alt={e.text} />
                </div>
                <div className="b2">
                    <a href={e.link} className="px-3 colorr">{e.text}</a>
                </div>
            </a>
        </div>
    );
})}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #1CA8CB',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#0AB4A9' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 9371304510" className="d-block  text-white">+91 9371304510</a>
                                                <a href="tel:+91 8379975860" className="d-block  text-white">+91 8379975860</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@moryacab.com" className=" text-white d-block">
                                                    booking@moryacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Morya Cab<br />
                                                    Gat no. 763 Jai Ganesh Niwas Flat no. 1 Lokhande Wasti Chimbali Pune, Maharashtra 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitotrimbkeshwertaxi;